<template>
  <n-space vertical>
  </n-space>
</template>

<script>
// import { defineComponent } from "vue";
import { useMessage } from "naive-ui";
import { apiLogout } from "@/apis/user/login";
import Cookies from "js-cookie";

export default {
  data() {
      return {
      }
  },
  setup() {
    window.$message = useMessage()
    // const message = useMessage();
    return {
      // username:'root',
      // password:'password',
      info() {
        // message.info("I don't know why nobody told you how to unfold your love", {
        //   keepAliveOnHover: true
        // });
      },
      // error() {
      //   message.error("Once upon a time you dressed so fine");
      // },
      warning() {
        // message.warning("How many roads must a man walk down");
      },
      success() {
        // message.success("'Cause you walked hand in hand With another man in my place");
      },
      loading() {
        // message.loading("If I were you, I will realize that I love you more than any other guy");
      }
    };
  },
  mounted() {
    apiLogout()
    Cookies.set('accessToken', '')
    this.$router.push(
      {
        name: 'UserLogin',
        params: {
        }
      }
    )
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
